<template>
  <v-app id="app">
    <template v-if="loggedin && isAuthenticated">
        <Navbar v-if="loggedin && isAuthenticated" />
    </template>
    <router-view
      :key="$route.fullPath"
      :style="widthValue === 0 && mini  ? 'padding: 64px 0px 0px 80px !important;' : ''"
    />
    <template v-if="loggedin && isAuthenticated">
      <Footer :version= "version"/>
    </template>
    <Snackbar :snackbar="snackbarStatus" :message="snackbarMessage"/>  
    <v-row justify="center" v-if="(( currentUser !=null && currentUser.hasOwnProperty('notice_read_status')) ? !currentUser.notice_read_status : false) && loggedin">
      <v-dialog  v-model="legalnotice" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">{{ 'Copyright legal notice' | translate }}</v-card-title>
          <v-card-text>
            <p class="mb-2 text-subtitle-1">{{ (legalnoticedata!== undefined ? legalnoticedata.page_content : "") }}</p>
            <h3 class="mb-3">{{ 'Intellectual Property Rights' | translate }}</h3>
            <p class="text-subtitle-1">{{ 'Unless otherwise indicated, the Site and all source code, database, functionality, software, website designs, audio, video, text, photographs, and other learning material on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (collectively, the “Marks”) are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of Germany, foreign jurisdictions, and international conventions.' | translate }}</p>
            <v-checkbox v-model="acceptstatus" :label="'I accept this (required)' | translate"></v-checkbox>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :color="acceptstatus ? 'green darken-1': 'grey darken-1' " text @click="(acceptstatus ? legalNoticeStatus(): '')">{{ 'Continue' | translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center" v-if="currentUser !=null && loggedin">
      <v-dialog v-model="profilecomplete" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">{{ 'Complete Your Personal Info' | translate }}</v-card-title>
          <v-card-text>
            <p class="mb-2 text-subtitle-1">{{ 'Please provide your personal information. All Details are mandatory and will appear in your certificate as shown below.'| translate}} </p>
            <h3 class="mb-3">{{ 'Personal Info' | translate }}</h3>
                <v-form id="form" ref="form">
                      <v-row>
                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="salutation"
                            :label="'Title' | translate"
                            autocomplete="off"
                            name="title"
                            :rules="salutationRules"
                            outlined
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                        <v-col cols="9" sm="9">
                          <v-text-field
                            outlined
                            :label=" 'Name' | translate"
                            v-model="name"
                            name="name"
                            :rules="nameRules"
                            autocomplete="off"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            outlined
                            :label="'Email' | translate"
                            v-model="email"
                            name="email"
                            :rules="emailRules"
                            autocomplete="off"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            outlined
                            :label="'Phone Number' | translate"
                            type="text"
                            v-model="phone_no"
                            name="phone_no"
                            class="phonenumber"
                            :rules="phoneRules"
                            autocomplete="off"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>  
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            name="address"
                            v-model="address"
                            :rules="addressRules"
                            autocomplete="off"
                            :label="'Address' | translate"
                          >
                        <template #message="{ message }">
                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                        </template>                            
                          </v-textarea>
                        </v-col>
                      </v-row>
                </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="update">{{ 'Update' | translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


  </v-app>
</template>

<script>
import Navbar from "./components/navbar/navbar.vue"
import Snackbar from "./components/snackbar/snackbar.vue"
import ApiService from "@/common/api.service";
import store from "@/store"
import axios from "axios"
import { mapGetters } from "vuex"
import { mapState } from "vuex"
import { UPDATE_USER, CHECK_AUTH } from "@/store/actions.type"
import { SET_LOADING,SET_SNACKBAR } from "@/store/mutations.type"
import { version } from "../package.json";

export default {
  name: "App",
  components: {
    Navbar,
    Snackbar,
    Footer: () => import('@/components/footer/footer')
  },
  computed: {
    isAuthenticated: function() {
      return this.$store.getters.isAuthenticated;
    },
    legalnotice: function() {
      return (this.currentUser.notice_read_status === 0 && this.loggedin ? true : false)
    },
    legalnoticedata: function (){
      let data = this.pagesdata.find(o=> o.page_slug == 'legalnotice')
      return data
    },
    profilecomplete: function() {
      this.setdata()
      return ((!this.currentUser.name||!this.currentUser.email|!this.currentUser.address|!this.currentUser.salutation) && this.loggedin ? true : false)
    },
    salutationvalues(){
      let salutationData = [
        { value: "Mr", name: this.$t("Mr") },
        { value: "Mrs", name: this.$t("Mrs") }
      ]
      return salutationData
    },  
    nameRules(){ 
      return [v => !!v || "Name is required"]
    },
    salutationRules(){ 
      return [v => !!v || "Title is required",
      (v) =>  (v && v.length <= 20) || "Title must be less than 20 characters"]
    },
    emailRules(){ 
      return [v => /.+@.+/.test(v) || "Invalid Email address"]
    },
    phoneRules(){ 
      return [
        v => !!v || "Phone Number is required",
        v => Number.isInteger(Number(v)) || "The value must be an integer number"
      ]
    },
    addressRules(){ 
      return [v => !!v || "Address is required"]
    },
    ...mapState({
      snackbarStatus: state => state.globals.snackbarStatus,
      snackbarMessage: state => state.globals.snackbarMessage,
    }),      
    ...mapGetters(["widthValue","currentUser",'loggedin', 'pagesdata', 'mini','curLanguage'])
  }, 
  async created() {
    document.title = process.env.VUE_APP_TITLE !== undefined && process.env.VUE_APP_TITLE.length > 0 ? process.env.VUE_APP_TITLE : 'Learn Ndt';
    var link = document.querySelector("link[rel~='icon']");
    link.href = this.$route.path+"./eefavi.png";    
    axios.interceptors.request.use(
      function(config) {
        if((config.url).includes('coupon/validate')){
          ApiService.setHeader();
          return config;
        }
        else{
          ApiService.setHeader();
          store.commit(SET_LOADING, true);
          return config;
        }
      },
      function(error) {
        return Promise.reject(error);
      }
    );
  },
  data: function() {
    return {
      acceptstatus: false,
      version: version,
      user_id:null,
      name: null,
      salutation: null,
      phone_no: null,
      email: null,
      address: null,
    }
  },
  methods:{
    setdata(){
      this.name = this.currentUser.name;
      this.salutation = this.currentUser.salutation;
      this.email = this.currentUser.email;
      this.address = this.currentUser.address;
      this.phone_no = this.currentUser.phone_no;
      this.user_id = this.currentUser.user_id;
    },
    async legalNoticeStatus () {
      await this.$store.dispatch(UPDATE_USER, {
            email: this.currentUser.email,
            name: this.currentUser.name,
            address: this.currentUser.address,
            phone_no: this.currentUser.phone_no,
            salutation: this.currentUser.salutation,
            user_id: this.currentUser.user_id,
            roles: this.currentUser.roles,
            notice_read_status: 1,
            _method: "put"
          })
          .then(async resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
             await this.$store.dispatch(CHECK_AUTH).then( async userresp =>{
              if(userresp !== undefined && userresp.hasOwnProperty('success') && userresp.success ==true){
                store.commit(SET_LOADING, false);
              }
             })
            }
          });
    },
     async update() {
      if (this.$refs.form.validate()) {
        await this.$store
          .dispatch(UPDATE_USER, {
            email: this.email,
            name: this.name,
            address: this.address,
            phone_no: this.phone_no,
            salutation: this.salutation,
            user_id: this.user_id,
            _method: "put"
          })
             .then(async resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
             await this.$store.dispatch(CHECK_AUTH).then( async userresp =>{
              if(userresp !== undefined && userresp.hasOwnProperty('success') && userresp.success ==true){
                store.commit(SET_LOADING, false);
                store.commit(SET_SNACKBAR, {status: true, message: 'Profile details updated successfully.'})
              }
             })
            }
          });
      }
    },
  }
};
</script>